export default "__VITE_ASSET__15LPAYVJ__"